/**
 * Form Builder sidebar tab values.
 */

export const QUESTIONS = 'questions';
export const STYLE = 'style';
